var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"items"},[_c('div',{staticClass:"item"},[_vm._v(" 毎日 ")])])}]

export { render, staticRenderFns }